import { render, staticRenderFns } from "./OrganisationOptions.vue?vue&type=template&id=a54fb49e"
import script from "./OrganisationOptions.vue?vue&type=script&lang=js"
export * from "./OrganisationOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports